module.exports = __webpack_public_path__ + "static/media/mg-motors-logo.189eb582.png";